export const environment = {
  production: true,
  apiBaseUrl: 'https://archiving.demo.code-icons.com/api/v1'
};
